const QUERY_STATES = ['fulfilled', 'pending', 'rejected']

export const asyncQueryBuilder = (builder, query, rest) => {
  QUERY_STATES.forEach(state => builder.addCase(query[state], rest[state]))
}
